/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseProfileData } from '../../models/api-response-profile-data';

export interface GetCompanyWaProfile$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  wabaPhoneId: string;
}

export function getCompanyWaProfile(http: HttpClient, rootUrl: string, params: GetCompanyWaProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProfileData>> {
  const rb = new RequestBuilder(rootUrl, getCompanyWaProfile.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('wabaPhoneId', params.wabaPhoneId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseProfileData>;
    })
  );
}

getCompanyWaProfile.PATH = '/v1/api/ui/company/wa-profile/{wabaPhoneId}';
